import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import PerformanceGoals from "./index";
import { FaBullseye } from "react-icons/fa6";
import ViewReport from "./view";
import EditReport from "./edit";
import { MODULE_REPORTS } from "variables/constants";

const performanceGoalsRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Performance & Goals",
		basePath: "performance-goals",
		mainComponent: <PerformanceGoals/>,
	    layout: "/console",	   
	    icon: <FaBullseye className="icon-item" />,
	    subTitle:"Performance & Goals",
	    viewComponent: <ViewReport />,
	    createComponent: <EditReport />,
	    editComponent: <EditReport />,
		level:4,
		moduleId: MODULE_REPORTS,
	})
]

export default performanceGoalsRoutes;